import { createGlobalStyle } from 'styled-components';

const ModalIn = createGlobalStyle`
  body,
  html {
    overflow: hidden;
  }
`;

export default ModalIn;
